<template>
  <dd-card class="skeleton-header-card ">
    <div class="flex-col gap-sm">
      <div class="flex-row align-items-center justify-content-between">
        <div class="flex-row gap-xs">
          <span v-if="hasIcon" class="icon animate-pulse">.</span>
          <span class="header animate-pulse" :style="{width: headerWidth} ">.</span>
        </div>
        <div v-if="actionCount" class="flex-row gap-xs">
          <span v-for="i in actionCount" class="action animate-pulse">.</span>
        </div>
      </div>
      <slot>
        <div class="skeleton-content animate-pulse">
          .
        </div>
      </slot>
    </div>
  </dd-card>
</template>

<script>
export default {
  name: "SkeletonHeaderCard.vue",
  props: {
    hasIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    headerWidth: {
      type: String,
      required: false,
      default: '100px',
    },
    actionCount: {
      required: false,
      type: Number,
      default: 0,
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.skeleton-header-card {
  .header {
    height: $font-size-large;
  }
  .icon {
    height: $font-size-large;
    width: $font-size-large;
  }
  .action {
    width: 30px;
    height: 30px;
    border-radius: $border-radius-base;
  }
  .skeleton-content {
    height: 240px;
    width: 100%;

  }
  .action, .header, .icon, .skeleton-content {
    background-color: $main-content-bg-color;
    border-radius: $border-radius-small;
    color: $main-content-bg-color;
  }

}
</style>
